import React from 'react'
import Button from "@mui/material/Button";

import googleLogo from 'assets/googleIcon.png';
import moodleLogo from 'assets/moodleIcon.png';

import {useStyles} from "./SignInButton.css";

const SignInButton = ({provider, onClick, ...props}) => {
    const classes = useStyles()

    const providerMapping = [
        {
            name: 'google',
            text: 'Sign in with Google',
            logo: googleLogo,
            style: classes.buttonGoogle

        },
        {
            name: 'moodle',
            text: 'Sign in with Moodle',
            logo: moodleLogo,
            style: classes.buttonMoodle
        }
    ]

    const getMappingByProvider = () => {
        return providerMapping.find(mapping =>
            mapping.name === provider
        )
    }

    return (
        <Button className={getMappingByProvider().style}
                variant="outlined"
                onClick={onClick}
                {...props}>
            <div className={classes.iconContainer}>
                <img className={classes.icon} src={getMappingByProvider().logo} alt='Login Button'/>
            </div>
            <div className={classes.buttonText}>{getMappingByProvider().text}</div>
        </Button>
    )
}

export default SignInButton
